import { dew as _CreateSnapshotRequestDew } from "./CreateSnapshotRequest";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CreateSnapshotRequest = void 0;
  var CreateSnapshotRequest_1 = _CreateSnapshotRequestDew();
  Object.defineProperty(exports, "CreateSnapshotRequest", {
    enumerable: true,
    get: function () {
      return CreateSnapshotRequest_1.CreateSnapshotRequest;
    }
  });
  return exports;
}